import styled from "styled-components";

const DEFAULT_DIMENSION = "24px";

const StyledIcon = styled.img<{ iconDimension?: number }>`
  width: ${({ iconDimension }) =>
    iconDimension ? `${iconDimension}px` : DEFAULT_DIMENSION};
  height: ${({ iconDimension }) =>
    iconDimension ? `${iconDimension}px` : DEFAULT_DIMENSION};
  margin: 0 auto;
`;

export { StyledIcon };
